import { createFileRoute } from "@tanstack/react-router";
import { options } from "@/pages/how-to-make-a-gif-size-smaller";

export const Route = createFileRoute("/blog/how-to-make-a-gif-size-smaller")(options);
